(function () {
  const rootElement = document.getElementById("jasani_product_builder");
  if (!rootElement || !window?.location?.pathname?.split("/")?.includes("logo-builder")) {
    return;
  }
  
  rootElement.innerHTML = `
        <div id="wrapper">
          <div class="tempCanvasForColorChange">
            <canvas id="tempCanvasForColorChange" width="500" height="500"></canvas>
          </div>
          <div class="loading" id="loadingSceen">
            <div class="loading-gif"></div>
          </div>
          <dialog id="logoLibraryDialog" class="logo-library-dialog">
          </dialog>
          <dialog id="previewDialog" class="preview-dialog">
            <div class="dialog-container">
              <div id="imageContainer" class="image-container"><div></div></div>
              <div class="modal-popup-toolBtn">
                <button class="new-primary-btn btn-sm" id="closePreviewBtn">Close</button>
                <button class="new-secondary-btn btn-sm" id="downloadImgPreview">Download</button>
              </div>
            </div>
          </dialog>
          <dialog id="uploadLogoDialog" class="upload-dialog">
            <div class="dialog-container-uploadLogo">
              <div>
                <input type="checkbox" id="removeBackgroundFromLogo" placeholder="" />
                <label for="removeBackgroundFromLogo">Remove Background From Logo</label>
              </div>
              <div class="modal-popup-toolBtn">
                <button class="primary" id="nextUploadLogoBtn">Choose file</button>
                <button class="secondary" id="closeUploadLogoBtn">Close</button>
              </div>
            </div>
          </dialog>
          <div class="main">
            <div id="content"></div>
          </div>
        </div>
      `;
})();
